import { oc } from '@orpc/contract';
import { generateReportInputSchema, generateReportOutputSchema } from '../schemas/reports.schemas.js';
export const generateReportContract = oc
    .route({
    method: 'POST',
    path: '/reports/generate',
    tags: ['Reports'],
    summary: 'Compute a draft report snapshot from one to six tests — writes nothing',
    description: 'The builder of plan §8: the same aggregation and compatibility code the compare screen runs — once per included test — turned into the printed document’s tables, per-test pages and generated sentences. Every test must be a scenario all the compared vehicles have a valid run under, otherwise the request is refused with a conflict. Nothing is written — the draft exists only in the response — and the three editable texts come back flagged separately so the builder knows what it may rewrite before saving.',
})
    .input(generateReportInputSchema)
    .output(generateReportOutputSchema);
//# sourceMappingURL=generate-report.contract.js.map